import {
  Component,
  PACKAGE_ROOT_URL,
  OnInit,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../main/accountant/accountant.service";
import { ConversationsService } from "../conversations.service";
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { FormUtil } from "../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { AutosizeModule } from "ngx-autosize";
import { InitialsDirective } from "../../../utils/initials.directive";
import { NgFor, NgClass, DatePipe } from "@angular/common";

/* This is a component which we pass in modal*/
@Component({
    selector: "comments-modal",
    templateUrl: "./comments-modal.component.html",
    imports: [
        NgFor,
        NgClass,
        InitialsDirective,
        FormsModule,
        AutosizeModule,
        DatePipe,
    ]
})
export class CommentsModalComponent implements OnInit, OnChanges {
  formUtil: FormUtil;
  message: any;
  user: any;
  tracked_item: any = { comments: [] };
  @ViewChild("inputMessage", { static: true }) inputMessage: ElementRef;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private conversationsService: ConversationsService,
    private localStorage: LocalStorageService,
    private toastr: HotToastService
  ) {}

  ngOnInit(): void {
    this.inputMessage.nativeElement.focus();
    this.user = this.localStorage.get("user");
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tracked_item = changes.tracked_item;
    // console.log(this.tracked_item);
  }

  send_message(): void {
    const msg = this.message;
    this.message = "";
    this.conversationsService
      .comment_tracked_item(this.tracked_item.id, msg)
      .then((res: any) => {
        this.message = "";
        this.inputMessage.nativeElement.focus();
      });
  }
}
